import React from 'react'
import TagsCollection from '../PopularTags'
import FadeIn from 'react-fade-in'
import { useNavigate } from 'react-router'
import { auth } from '../../firebase'
import { useContext } from 'react'
import { UserContext } from '../../Helpers/user.context'
export default function Right({ tags }) {
    const navigate = useNavigate()
    const user = useContext(UserContext)
    return (
        // <div style={{ position: "absolute" }}>
        <div style={{ gap: 30, padding: "30px", boxSizing: "border-box", background: "#fff", marginLeft: 20, borderRadius: 20, position: "fixed", maxWidth: 450 }} className="flex fdc aic rightSidebar">
            <div className='flex aic' style={{ gap: 15, width: "100%" }}>
                <h1 className='trendingTagsText' style={{ margin: 0 }}>Trending Tags</h1>
            </div>
            <FadeIn className='tagRankingsContainer'>
                {tags.map((tag, index) => {
                    return (
                        <div key={index} className='flex aic jcsb rightSidebarRankContainer' style={{ gap: 15 }}>
                            <div className='tag'>
                                {tag}
                            </div>
                        </div>
                    )
                })}
            </FadeIn>
            {auth.currentUser && !user.isPro
                ? <button onClick={() => navigate("/pro")} className="b3 flex aic jcc" style={{ width: "100%", textAlign: "center", gap: 10 }}>
                    <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#fff"><g><rect fill="none" height="24" width="24" /></g><g><g><path d="M23,11.99l-2.44-2.79l0.34-3.69l-3.61-0.82L15.4,1.5L12,2.96L8.6,1.5L6.71,4.69L3.1,5.5L3.44,9.2L1,11.99l2.44,2.79 l-0.34,3.7l3.61,0.82L8.6,22.5l3.4-1.47l3.4,1.46l1.89-3.19l3.61-0.82l-0.34-3.69L23,11.99z M19.05,13.47l-0.56,0.65l0.08,0.85 l0.18,1.95l-1.9,0.43l-0.84,0.19l-0.44,0.74l-0.99,1.68l-1.78-0.77L12,18.85l-0.79,0.34l-1.78,0.77l-0.99-1.67l-0.44-0.74 l-0.84-0.19l-1.9-0.43l0.18-1.96l0.08-0.85l-0.56-0.65l-1.29-1.47l1.29-1.48l0.56-0.65L5.43,9.01L5.25,7.07l1.9-0.43l0.84-0.19 l0.44-0.74l0.99-1.68l1.78,0.77L12,5.14l0.79-0.34l1.78-0.77l0.99,1.68l0.44,0.74l0.84,0.19l1.9,0.43l-0.18,1.95l-0.08,0.85 l0.56,0.65l1.29,1.47L19.05,13.47z" /><polygon points="10.09,13.75 7.77,11.42 6.29,12.91 10.09,16.72 17.43,9.36 15.95,7.87" /></g></g></svg>
                    Upgrade to PRO
                </button>
                : null
            }
        </div>
        // </div>
    )
}
